import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { GALLERY } from "../../data";
import { Reveal, Eyebrow, H2 } from "./Typo";

const SPANS = [
  "md:col-span-7 md:row-span-2 aspect-[4/5] md:aspect-auto",
  "md:col-span-5 aspect-[4/3]",
  "md:col-span-5 aspect-[4/3]",
  "md:col-span-4 aspect-[3/4]",
  "md:col-span-4 aspect-[3/4]",
  "md:col-span-4 aspect-[3/4]",
];

export default function OurWork({ bare = false }) {
  return (
    <section id="our-work" data-testid="our-work-section" className="section-pad bg-white">
      <div className="container-hw">
        {!bare && <div className="grid lg:grid-cols-12 gap-8">
          <Reveal className="lg:col-span-6">
            <Eyebrow>Our work</Eyebrow>
            <H2 className="mt-6">Quality You Can See.</H2>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-5 lg:col-start-8 self-end">
            <p className="text-[1.05rem] leading-relaxed text-[#3E474B]">We believe the details matter. From system selection to installation, we want every project to reflect the care and quality our customers expect.</p>
          </Reveal>
        </div>}
        <div className={`${bare ? "" : "mt-14 md:mt-20"} grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5`}>
          {(bare ? GALLERY : GALLERY.slice(0, 6)).map((g, i) => (
            <Reveal as="figure" key={g.src} delay={(i % 3) * 0.06} data-testid={`work-${i}`} className={"group relative overflow-hidden bg-[#D9D6CC] " + SPANS[i % 6]}>
              <img src={g.src} alt={`Honest Water LLC installation: ${g.caption}`} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] group-hover:scale-[1.03]" />
              <figcaption className="absolute left-0 bottom-0 bg-[#172B38] text-[#F4F1E9] text-[0.8rem] px-3.5 py-2">{g.caption}</figcaption>
            </Reveal>
          ))}
        </div>
        {!bare && <Reveal className="mt-12">
          <Link to="/gallery" data-testid="work-view-all" className="inline-flex items-center gap-2 text-[0.95rem] text-[#172B38] border-b border-[#172B38] pb-0.5">View more installations <ArrowRight className="w-4 h-4" strokeWidth={1.5} /></Link>
        </Reveal>}
      </div>
    </section>
  );
}
